// @flow

import React from 'react';
import Dialog, { DialogButton } from '../../components/Dialog';
import { Centered } from '../../components';
import { Anchor } from '../components';
import {
  TERMS_ACCEPT_LABEL,
  TERMS_DECLINE_LABEL,
  TERMS_LINK_LABEL,
  TERMS_MESSAGE_PREFIX,
  TERMS_MESSAGE_SUFFIX,
  TERMS_URL,
} from './termsCopy';

type Props = {
  onClose?: Function,
  onAccept: Function,
  onDecline: Function,
};

const noop = () => {};
const AcceptTermsDialog = (props: Props) => (
  <Dialog onClose={props.onClose || noop}>
    <Centered>
      {TERMS_MESSAGE_PREFIX}{' '}
      <Anchor href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        {TERMS_LINK_LABEL}
      </Anchor>
      {TERMS_MESSAGE_SUFFIX}
    </Centered>
    <DialogButton onClick={props.onAccept}>{TERMS_ACCEPT_LABEL}</DialogButton>
    <DialogButton variant="secondary" onClick={props.onDecline}>
      {TERMS_DECLINE_LABEL}
    </DialogButton>
  </Dialog>
);

export default AcceptTermsDialog;



// WEBPACK FOOTER //
// ./src/Auth/Signup/AcceptTermsDialog.js